/* eslint-disable no-unused-vars */
import axios from 'axios';
import moment from 'moment';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/actions`;

const state = {
    actions: [],
    action_templates: [],
    action_count: null,
};

const getters = {
    allActions: state => state.actions,
    allActionTemplates: state => state.action_templates,
    totalActionCount: state => state.action_count
};

const actions = {
    async fetchActions({ commit }, filter) {
        try {
            const authToken = localStorage.getItem('access_token');
            let headers = { 'x-drmms-token': authToken };
            if (filter.bypass)
                headers = Object.assign(headers, {
                    'x-bypass-token': localStorage.getItem('bypass_key')
                })

            // if(filter.page) customFilter += `?page=${filter.page}`;

            const customUrl = url + '?limit=0';

            const response = await axios.get(customUrl, { headers });
            let actions = response.data.rows.map((action) => ({
                ...action,
                date: moment(action.createdAt).format('LLL'),
            }));
            commit('setActions', { actions, count: response.data.count, limitChangeStatus: filter.limitChangeStatus });
        } catch (err) {
            console.log(err);
        }
    },
    async fetchActionTemplate({ commit }, action_id) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/templates/${action_id}`, { headers: { 'x-drmms-token': authToken }});

            commit('addActionTemplate', response.data);

            return true;
        } catch(err) {
            console.log(err);
        }
    },
    async createAction({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(url, body, {
                headers: { 'x-drmms-token': authToken }
            });

            let newAction = Object.assign(response.data, { date: moment(response.data.createdAt).format('LLL') });
            commit('newAction', newAction);
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    },
    async createActionTemplate({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(`${url}/template`, body, {
                headers: { 'x-drmms-token': authToken }
            });

            commit('newActionTemplate', {action_id: body.action_id, statuses: body.statuses});
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    },
    async deleteAction({ commit }, id) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.delete(`${url}/${id}`, {
                headers: { 'x-drmms-token': authToken }
            });
            console.log(id);
            commit('removeAction', id);
            return response;
        } catch (err) {
            console.log(err);
        }
    },
    async updateAction({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: 'put',
                url: `${url}/${body.id}`,
                headers: { 'x-drmms-token': authToken },
                data: {
                    name: body.name,
                    description: body.description,
                    label: body.label,
                    hasDueDate: body.hasDueDate
                }
            });
            commit('updateAction', body);
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    }
};

const mutations = {
    setActions: (state, {actions, count, limitChangeStatus }) => state.actions = actions,
    newAction: (state, action) => state.actions.push(action),
    removeAction: (state, id) => {
        for (let i = 0; i < id.length; i++) {
            state.actions = state.actions.filter(action => action.id !== id[i])
        }
    },
    updateAction: (state, updAction) => {
        const index = state.actions.findIndex(action => action.id === updAction.id);
        if (index !== -1) {
            let editingItem = state.actions[index];
            let editedItem = Object.assign(editingItem, updAction);
            state.actions.splice(index, 1, editedItem);
        }
    },
    newActionTemplate: (state, body) => {
        state.action_templates = state.action_templates.filter((temp) => temp.action_id != body.action_id);
        state.action_templates.push(body);
    },
    addActionTemplate: (state, action) => state.action_templates.push(action)
};

export default {
    state,
    getters,
    actions,
    mutations,
}